__turbopack_context__.v({
  "active": "main-sidebar-live-module-sass-module__gu8gnW__active",
  "gamesCount": "main-sidebar-live-module-sass-module__gu8gnW__gamesCount" + " " + __turbopack_context__.i(488939)["gamesCount"],
  "popoverContent": "main-sidebar-live-module-sass-module__gu8gnW__popoverContent" + " " + __turbopack_context__.i(488939)["popoverContent"],
  "subNav": "main-sidebar-live-module-sass-module__gu8gnW__subNav" + " " + __turbopack_context__.i(488939)["subNav"],
  "subNavItem": "main-sidebar-live-module-sass-module__gu8gnW__subNavItem" + " " + __turbopack_context__.i(488939)["subNavItem"],
});
